import { useNavigate } from "react-router-dom";
import "../../styles/about/aboutCTA.css";

const AboutCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="about-cta">
      <div className="about-cta-inner">
        <h2 className="about-cta-title">
          Learn concepts the way your brain understands them
        </h2>

        <p className="about-cta-description">
          Explore visual explanations built to simplify complex ideas.
        </p>

        <button
          className="primary-btn"
          onClick={() => navigate("/visualizations")}
        >
          Explore Visualizations
        </button>
      </div>
    </section>
  );
};

export default AboutCTA;
